import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import HeaderPriceTooltipCard from 'contest/components/header-price-tooltip-card';
import { Tooltip } from '@99designs/common/components/Tooltip';
import { Icon } from '@99designs/common/components/Icon';

class HeaderPrice extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { userType } = this.props;

        const card = (
            <HeaderPriceTooltipCard
                userType={this.props.userType}
                prizeMoney={this.props.prizeMoney}
                poolMoney={this.props.poolMoney}
                hasPoolMoney={this.props.hasPoolMoney}
                startDate={this.props.startDate}
                minimumDesignerLevel={this.props.minimumDesignerLevel}
            />
        );

        const showPrizeMoney =
            userType === 'entrant_designer' || userType === 'non_entrant_designer';

        return (
            <div className="contest-price">
                <div className="contest-price__body">
                    <Tooltip hoverableElementVariations={['block']} tooltip={card}>
                        {userType === 'owner' && (
                            <div className="contest-price__primary">
                                <span
                                    className={`pill pill--offset-left pill--${
                                        this.props.packageName
                                    }`}
                                >
                                    <FormattedMessage id="price_package_name" />
                                </span>
                                <span className="contest-price__primary__icon">
                                    <Icon type={'info-1'} variations={['lighter', 'offset-left']} />
                                </span>
                            </div>
                        )}
                        {userType !== 'owner' && (
                            <div className="contest-price__primary">
                                <span>
                                    {showPrizeMoney
                                        ? this.props.prizeMoney
                                        : this.props.purchasePrice}
                                </span>
                                <span
                                    className={`pill pill--offset-left pill--${
                                        this.props.packageName
                                    }`}
                                >
                                    <FormattedMessage id="price_package_name" />
                                </span>
                            </div>
                        )}
                    </Tooltip>
                    {this.props.hasPoolMoney &&
                        showPrizeMoney && (
                            <div className="contest-price__secondary">+ {this.props.poolMoney}</div>
                        )}
                </div>
            </div>
        );
    }
}

HeaderPrice.propTypes = {
    prizeMoney: PropTypes.string.isRequired,
    purchasePrice: PropTypes.string.isRequired,
    poolMoney: PropTypes.string.isRequired,
    hasPoolMoney: PropTypes.bool.isRequired,
    startDate: PropTypes.string.isRequired,
    minimumDesignerLevel: PropTypes.string.isRequired,
    packageName: PropTypes.oneOf(['bronze', 'silver', 'gold', 'platinum', 'custom']).isRequired,
    userType: PropTypes.oneOf([
        'owner',
        'entrant_designer',
        'non_entrant_designer',
        'admin',
        'other_customer',
        'logged_out',
    ]).isRequired,
};

export default HeaderPrice;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/header-price.jsx